import React from "react";
import useAuthenticatedImage from "../hooks/useAuthenticatedImage";
import Icon from "./Icon";

export default function AuthenticatedImage({ path, context = "parent", alt = "", className = "", style, "data-testid": testId = "private-photo" }) {
  const { src, status, imageFailed } = useAuthenticatedImage(path, context);
  if (!src) {
    return (
      <span className={`${className} inline-flex min-h-[2.75rem] items-center justify-center bg-slate-100 text-ink-muted`}
        style={style} role={alt ? "img" : undefined} aria-label={alt ? `${alt}: ${status === "loading" ? "loading photo" : "photo unavailable"}` : undefined}
        aria-hidden={alt ? undefined : true} aria-busy={status === "loading" || undefined} data-testid={testId}>
        <Icon name="image" width={20} height={20} aria-hidden="true" />
      </span>
    );
  }
  return <img src={src} alt={alt} className={className} style={style} data-testid={testId}
    decoding="async" referrerPolicy="no-referrer" onError={imageFailed} />;
}
